// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".amount-input-size[data-v-538ae5a2]{width:60%;height:100%;float:left}.total-amount-input-size[data-v-538ae5a2]{width:40%;height:100%;color:#515a6e;float:right}.warning-label[data-v-538ae5a2]{color:red}", ""]);
// Exports
module.exports = exports;
